import { render } from "./kongqiulv.vue?vue&type=template&id=dc747d28&scoped=true"
import script from "./kongqiulv.vue?vue&type=script&lang=js"
export * from "./kongqiulv.vue?vue&type=script&lang=js"

import "./kongqiulv.vue?vue&type=style&index=0&id=dc747d28&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc747d28"]])

export default __exports__